import script from "./ShareRequestModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareRequestModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__